import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Base, { Breadcrumbs } from '../../layout';
import OrganisationServices from '../../services/organization.services';
import Pagination from 'react-js-pagination';

const OrganizationAccounts = function () {
    const history = useHistory();
    const [organisations, setOrganisations] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const addNewAccount = (e) => {
        e.preventDefault();
        history.push({ pathname: '/organisation/0' });
    };
    useEffect(() => {
        getOrgs();
    }, []);
    function getOrgs(requestedPageNumber) {
        OrganisationServices.organisations(requestedPageNumber)
            .then((res) => {
                setOrganisations(res.data.data);
                setTotalCount(res.data.metadata.total);
            })
            .catch((err) => {
                console.log(err);
            });
    }
    const deleteOrganisation = (id) => {
        let isConfirm = confirm('Are you sure to delete the account?');
        if (isConfirm) {
            OrganisationServices.deleteOrganisation(id)
                .then(() => {
                    getOrgs();
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };
    const suspendUnsuspend = (id, state) => {
        let dynamic = 'Suspend';
        if (!state) {
            dynamic = 'Active';
        }
        let isConfirm = confirm(`Are you sure to ${dynamic} the account?`);
        if (isConfirm) {
            OrganisationServices.suspend(id, state).then((res) => {
                console.log(res);
                getOrgs();
            });
        }
    };
    const handlePageChange = (id) => {
        setPageNumber(id);
        getOrgs(id);
    };
    return (
        <Base>
            <Breadcrumbs title="Organizations" />
            <div className="block full">
                <div className="block-title pad-20">
                    <h2>Accounts</h2>
                    <div className="pull-right">
                        <button onClick={addNewAccount} className="btn btn-effect-ripple btn-lg btn-primary">
                            <i className="fa fa-plus"></i>
                            Add Account
                        </button>
                    </div>
                </div>
                <div className="table-responsive">
                    <table id="example-datatable" className="table table-striped table-bordered table-vcenter">
                        <thead>
                            <tr>
                                <th>Account Number</th>
                                <th>Company</th>
                                <th>Description</th>
                                <th>No. of Users</th>
                                <th>Edit</th>
                                <th>Account Status</th>
                                <th>Suspend Account</th>
                                <th>Delete Account</th>
                            </tr>
                        </thead>
                        <tbody>
                            {organisations.length > 0 &&
                                organisations.map((organisation) => (
                                    <tr key={organisation.id}>
                                        <td>{organisation.id}</td>
                                        <td>{organisation.name}</td>
                                        <td>{organisation.description}</td>
                                        <td>{organisation.OrganisationEmployee.length}</td>
                                        <td>
                                            <Link
                                                to={`/organisation/${organisation.id}`}
                                                data-toggle="tooltip"
                                                title="Edit Organisation"
                                                className="btn btn-effect-ripple btn-xs btn-success">
                                                <i className="fa fa-pencil"></i>
                                            </Link>
                                        </td>
                                        <td>{organisation.isSuspended ? 'Suspended' : 'Active'}</td>
                                        <td>
                                            {organisation.isSuspended ? (
                                                <button
                                                    onClick={() => {
                                                        suspendUnsuspend(organisation.id, !organisation.isSuspended);
                                                    }}
                                                    type="submit"
                                                    className="btn btn-effect-ripple btn-primary">
                                                    Active
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => {
                                                        suspendUnsuspend(organisation.id, !organisation.isSuspended);
                                                    }}
                                                    type="submit"
                                                    className="btn btn-effect-ripple btn-primary">
                                                    Suspend
                                                </button>
                                            )}
                                        </td>
                                        <td>
                                            <button
                                                onClick={() => {
                                                    deleteOrganisation(organisation.id);
                                                }}
                                                type="reset"
                                                className="btn btn-effect-ripple btn-danger">
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <Pagination
                        activePage={pageNumber}
                        itemsCountPerPage={10}
                        totalItemsCount={totalCount}
                        pageRangeDisplayed={10}
                        onChange={handlePageChange}
                    />
                </div>
            </div>
        </Base>
    );
};
export default OrganizationAccounts;
